// Supported currencies (matches user profile: Profile.jsx).
// These 4 are the only currencies the app supports.
export const SUPPORTED_CURRENCIES_WITH_FLAGS = [
	{ code: 'USD', flag: '🇺🇸', name: 'US Dollar' },
	{ code: 'EUR', flag: '🇪🇺', name: 'Euro' },
	{ code: 'AMD', flag: '🇦🇲', name: 'Armenian Dram' },
	{ code: 'RUB', flag: '🇷🇺', name: 'Russian Ruble' },
];

// Alias for backward compatibility (sidebar-header uses this)
export const CURRENCIES_WITH_FLAGS = SUPPORTED_CURRENCIES_WITH_FLAGS;

export const SUPPORTED_CURRENCY_CODES = SUPPORTED_CURRENCIES_WITH_FLAGS.map(
	c => c.code,
);

export const getCurrencyFlag = code => {
	const found = SUPPORTED_CURRENCIES_WITH_FLAGS.find(c => c.code === code);
	return found ? found.flag : '💱';
};
